export default {
  logistics: {
    breadcrumbHome: 'الرئيسية',
    breadcrumbSolutions: 'الحلول',
    breadcrumbCurrent: 'المستودعات واللوجستيات',
    hero: {
      eyebrow: 'المستودعات واللوجستيات',
      title: 'مراقبة مساحات واسعة للوجستيات والمستودعات',
      lead: 'زاوية واسعة وPTZ ورؤية ليلية – نغطي القاعات الكبيرة والمساحات الخارجية بعدد قليل من الكاميرات الموضوعة جيدًا.',
    },
    areas: {
      title: 'مناطق المراقبة في المستودعات واللوجستيات',
      lead: 'من المدخل إلى التغليف: ننظّم مراقبتك على طول تدفق البضائع – فلا تظهر ثغرات.',
      items: {
        '0': { title: 'الدخول والخروج', desc: 'كل مركبة تعبر موقعك تُلتقط – مع لوحة الترخيص والطابع الزمني لتوثيق كامل.' },
        '1': { title: 'منطقة التسليم', desc: 'وصول البضائع وسحبها لحظات حساسة. الكاميرات توثّق كل حركة عند الرصيف.' },
        '2': { title: 'الرفوف', desc: 'القاعات الكبيرة تحتاج حلولًا كبيرة. كاميرات PTZ تمسح الممرات وتقرّب حتى المنصة عند الحاجة.' },
        '3': { title: 'تجهيز الطلبات', desc: 'التغليف والتجهيز يتسمان بالحركة. كاميرات النظرة العامة توضح الشكاوى.' },
        '4': { title: 'الخارج والساحة', desc: 'المحيط هو خط الدفاع الأول. كاميرات مقاومة للطقس تراقب الأسوار والبوابات والمركبات.' },
        '5': { title: 'المكتب والإدارة', desc: 'المنطقة الإدارية تحتاج حماية أيضًا – للأشياء الثمينة والوثائق والمداخل الحساسة.' },
      },
    },
    coverage: {
      eyebrow: 'مساحات واسعة تحت المراقبة',
      title: 'كاميرا واحدة، أثر كبير',
      lead: 'في المستودعات تهم النظرة الشاملة. بدلًا من كاميرات منفصلة كثيرة، نستخدم تقنية تغطي المساحات الكبيرة بذكاء.',
      items: {
        '0': { title: 'كاميرات PTZ', desc: 'تدوير وإمالة وتقريب – كاميرا واحدة تغطي مساحات كبيرة وتعطي تفاصيل عند الحاجة.' },
        '1': { title: 'نظرة زاوية واسعة', desc: 'لأقسام القاعات والمناطق الخارجية: كاميرات زاوية واسعة مدمجة تلتقط مساحات كبيرة في صورة واحدة.' },
        '2': { title: 'رؤية نهارية وليلية', desc: 'الأشعة تحت الحمراء ومستشعرات حساسة تعطي صورًا قابلة للاستخدام حتى في الظلام – على مدار الساعة.' },
      },
    },
    roundClock: {
      eyebrow: 'على مدار الساعة',
      title: 'تسجيل لا ينام',
      lead: 'حركة البضائع لا تتوقف ليلًا. نظامك يسجل على مدار الساعة ويجعل الأحداث ذات الصلة قابلة للعثور فورًا.',
      list: {
        '0': 'تسجيل 24/7 على مسجّل محلي بمدة حفظ محددة',
        '1': 'التسجيل حسب الأحداث يوفر المساحة ويسهّل البحث',
        '2': 'إعادة توجيه الإنذار لأشخاص محددين عند الحركة في المناطق المحظورة',
        '3': 'صيانة دورية من SSG Care لتوافر دائم',
        '4': 'قابل للتوسعة بكاميرات إضافية ومواقع أخرى',
      },
      note: 'ملاحظة: يجب تكييف مدة حفظ التسجيلات مع المتطلبات التشغيلية والقانونية. ننصحك بذلك.',
    },
    cta: {
      title: 'لوجستياتك – موثقة دون ثغرات',
      lead: 'نحلل تدفق البضائع ونقاط الخطر ونخطط نظامًا يناسب هيكل قاعتك.',
      primary: 'احجز موعد استشارة',
      secondary: 'اكتشف SSG Care',
    },
  },
};